import { GeneralProps } from 'gossamer-front-end';

const COLOUR_MAPPING: Record<string, string> = {
  RED: 'rgba(var(--bs-danger-rgb))',
  AMBER: 'rgba(var(--bs-warning-rgb))',
  GREEN: 'rgba(var(--bs-success-rgb))',
};

export const UneditableRagStatus = (props: GeneralProps) => {
  const status = String(props.value || '').toUpperCase();
  return <div style={{ color: COLOUR_MAPPING[status] }}>⬤</div>;
};
